// removed by extract-text-webpack-plugin
module.exports = {"phoneImgContainer":"G062c52","phoneImg":"Gb7f334"};